module.exports = __webpack_public_path__ + "staticcomp/img/top.9c80e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/3/top.jpg
// module id = QoKC
// module chunks = 39